import { render, staticRenderFns } from "./BasePrimaryActionButton.vue?vue&type=template&id=67e2fc7b&scoped=true&"
import script from "./BasePrimaryActionButton.vue?vue&type=script&lang=js&"
export * from "./BasePrimaryActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2fc7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VIcon,VScaleTransition})
